'use strict';
var _ = require('lodash');
var assert = require('assert');
var crypto = require('crypto');
var calculatePrice = require('../calculatePrice');

const HttpError = require('http-errors');



var TEAMS_BLOCKED = []

module.exports = function (Order) {



  /** 
   * Place an order
   */
  Order.place = async function(req){

    try {
      return await Order.runPlace(req);
    } catch (error) {
      console.error("Erro ao processar a compra:", error);
      throw new HttpError.BadRequest(error.message);
    }
  }

  /** 
   * Place an order
   */
  Order.runPlace = async function(req){

    // TODO - evitar posts duplicados. e se varios forem enviados ao mesmo tempo? como fazer isso? trato uma fila?
    // console.log("TEAMS_BLOCKED", TEAMS_BLOCKED);
    // console.log("Date.now()", Date.now());
      // remove all teams block 10s old
      TEAMS_BLOCKED = _.filter(TEAMS_BLOCKED, t => t.time > Date.now() - 1000 * 15);
      // console.log("TEAMS_BLOCKED CLEANED", TEAMS_BLOCKED);
    
      console.log("========== ORDER.place - start")
  
      const data = req.body;

      let Models = Order.app.models;

      let order = data.order;
      let purshaseProducts = data.purshaseProducts;
      let products = _.map(data.purshaseProducts, ps => ps.product);
      let eventId = data.eventId;
      let buyer = data.buyer;
      let payment = data.payment;
      let clientId = data.clientId;


      _.each(purshaseProducts, purshaseProduct=>{
        const teamInfo = JSON.stringify(purshaseProduct.team[0].infos);
        if(TEAMS_BLOCKED.some(t => t.teamInfo === teamInfo)){
          throw new Error('Já existe uma pedido sendo processada com o mesmo nome de equipe. Aguarde a conclusão da compra.');
        }else{
          TEAMS_BLOCKED.push({teamInfo, time:Date.now()});
        }
        
      })
      

      //cupom
      let cupomId = data.cupomId || _.get(data, 'order.cupomId') || null;
      let cupom;
      if(cupomId){
        cupom = await Models.Cupom.findById(cupomId);
      }

      

      let newOrder = (_.isString(order.id) && order.id.match(/new/) )
      let orderModel;
      let buyerModel = {id:null};

      //get the event info
      var eventInfo = await Models.Event.products(eventId);

      //just to make sure to get products from the server,
      //to not trust product received from the frontend
      _.each(purshaseProducts, purshaseProduct=>{
           purshaseProduct.product =  _.find(eventInfo.products, {id:purshaseProduct.productId});
      })

      var totalPrice = calculatePrice.getFinalPriceForEvent(purshaseProducts,eventInfo,cupom);
      var totalDiscount = calculatePrice.getTotalDiscount(purshaseProducts,eventInfo);
      // var discountsApplied = calculatePrice.getDiscountInfo(purshaseProducts,eventInfo);

      // var products = getters.purshaseProductsForCurrentOrder;
      let productDiscountsRules = eventInfo.discounts || []
      let memberDiscountsRules = eventInfo.memberDiscounts || []
      let teamDiscountsRules = eventInfo.teamDiscounts || []
      // let cupom = getters.cupom
      var discountsApplied = calculatePrice.getDiscounts( purshaseProducts, [...productDiscountsRules],  [...memberDiscountsRules],  [...teamDiscountsRules], null )





      var totalTax = 0;

      let orderDescription = "";
      _.each(products, product=>{
          orderDescription+=''+product.fullname;
      })

      let buyerInfo;
      let clientInfos = await Models.Client.findById(clientId);

      if(!order.payed){
        if( ! _.isEmpty( _.get(buyer,'name') ) ){
            if( !_.isEmpty(order.buyerId) ) buyer.buyerId = order.buyerId
            buyerModel = await Models.Buyer.upsert( buyer );
        }
      }else{
        if(order.buyerId)
          buyerModel= {id:order.buyerId}
      }

      //check if order exists
      if( _.isString(order.id) && order.id.match(/new/) ){

          // vejo se ja tem uma ordem com o mesmo nome de equipe etc
          // const clientTeams = await Models.Team.find({where:{clientId:clientId},
          //   include: [
          //     {
          //       relation: 'purchaseProduct',
          //       scope: {
          //         where: { eventId: eventId },
          //       },
          //     },
          //   ],
          // });

            // 1. Busca os purchaseProducts do eventId=12, já incluindo o Team
          const pps = await Models.PurchaseProduct.find({
            where: { 
              and:[ 
                {eventId: eventId},
                {clientId:clientId},
                {paymentStatus: {neq:null} } 
              ]
             },
            
            include: {
              relation: 'team',
              scope: { where: { clientId } }
            }
          });

          const clientTeams = [];
           _.each(pps, pp =>{
            const obj = pp.toJSON();
            if(obj.payed || obj.payedByAdmin || obj.paymentStatus == 'waiting'){
              clientTeams.push(obj.team);
            }
          }); 

          const teamsInOrder = _.map(purshaseProducts, pp => pp.team[0]);
          console.log("----- teamsInOrder ALL:", teamsInOrder);
          for(let i = 0; i < clientTeams.length; i++){
            const teamsInDB = clientTeams[i];
            // console.log("teamsInOrder", teamsInOrder);
            console.log("teamsInDB", teamsInDB);
            // teams is a json object, can have similar
            _.some(teamsInOrder, teamInOrder => {
              console.log("teamInOrder Info", teamInOrder.infos);
              console.log("teamsInDB Info", teamsInDB.infos);
              if (_.isEqual(teamInOrder.infos, teamsInDB.infos)) {
                if(obj.paymentStatus == 'waiting')
                throw new Error('Já existe uma equipe com este nome em suas inscrições. Por favor, acesse as informações dos atletas e escolha outro nome para a equipe. ');
              }
              return false;
            });
          }
        

        // verifico se a ultima compra do cliente voi a menos de 3 minutos
        const lastOrder = await Order.findOne({where:{clientId:clientId}, order:'created DESC'});
        if(lastOrder){
          const threeMinutesAgo = new Date(Date.now() - 1 * 60 * 1000);
          if(lastOrder.created > threeMinutesAgo){
            throw new Error('Você realizou uma compra há menos de 1 minuto. Por favor, aguarde alguns instantes antes de realizar uma nova compra.');
          }
        }


        
        try {
            orderModel = await Order.create({totalPrice,totalDiscount, orderDescription, eventId, clientId:clientId, buyerId:buyerModel.id, cupomId:cupomId, discountsApplied});
        } catch (error) {
            console.error("Erro ao criar o pedido:", error);
            throw error;
        }finally{
          const a = orderModel;
          //LETODO - send email to buyer with order token
        }

      }else{
        orderModel = await Order.findById(order.id);
        if(order.payed){
          orderModel = await Order.upsert( {...order,buyerId:buyerModel.id} );
        }else{
          orderModel = await Order.upsert({...order, buyerId:buyerModel.id, totalPrice,totalDiscount, orderDescription});
         
        
        }
      }

      //now save products for the order
      for (let i = 0; i < purshaseProducts.length; i++) {
        const purshaseProduct = purshaseProducts[i];
        let myClienteId = clientId;
        if( _.isString(purshaseProduct.id) && purshaseProduct.id.match(/new/) ){
          delete purshaseProduct.id
        }
        if( _.has(purshaseProduct,clientId) ){
          myClienteId =  purshaseProduct.myClienteId
        }
        // let purshaseProductModel = await orderModel.purchaseproducts.upsert( {...purshaseProduct} )
        let purshaseProductModel = await Models.PurchaseProduct.upsert( {
                                        ...purshaseProduct, 
                                        name:purshaseProduct.product.fullname, 
                                        orderId:orderModel.id,
                                        clientId:myClienteId, 
                                        buyerId:buyerModel.id,
                                        eventId:eventInfo.id,
                                    })
        
        for (let ii = 0; ii < purshaseProduct.members.length; ii++) {
          const member = purshaseProduct.members[ii];
          if( _.isString(member.id) && member.id.match(/new/) ){
            delete member.id
          }
          // let memberModel = await purshaseProductModel.members.upsert(member)
          let memberModel = await Models.Member.upsert({...member, purchaseProductId:purshaseProductModel.id, clientId:clientId, buyerId:buyerModel.id })

        }

        if( ! _.isEmpty(purshaseProduct.team[0]) ){
          if( _.isString(purshaseProduct.team[0].id) && purshaseProduct.team[0].id.match(/new/) ){
            delete purshaseProduct.team[0].id
          }
          let teamModel = await Models.Team.upsert( {...purshaseProduct.team[0], purchaseProductId:purshaseProductModel.id, clientId:clientId, buyerId:buyerModel.id } )
        }
      }
      
      //Pay the order
      if( !order.payed && order.payedByAdmin !== false && orderModel.totalPrice > 0 ){
          var payInfo = await orderModel.createPayment( _.get(data,'paymentInfo',{}), _.get(data,'paymentOptionId',null), buyerModel.id, req );
      }else if(totalPrice <= 0){
        orderModel.payed = true;
        orderModel.paymentStatus = 'payed';
        await orderModel.save();
      }

      var completeOrder = await Order.info({token:orderModel.token})

      //send email  
      if(newOrder){
        // envio o boas vindas com delay, para dar tempo de processar o pagamento
        setTimeout( ()=>{
          Order.sendOrderPlaceEmail(completeOrder.token)
        },5000)
      }


      console.log("========== ORDER.place - end")


      return { order:completeOrder, payment:payInfo}
  
    }


  /* 
    Save an existent order
  */
  Order.save = async function(req){


    console.log("========== ORDER.save")

   
    const data = req.body;

    let Models = Order.app.models;

    let order = data.order;
    let purshaseProducts = data.purshaseProducts;
    let products = _.map(data.purshaseProducts, ps => ps.product);
    let eventId = data.eventId;
    let buyer = data.buyer;
    let payment = data.payment;
    let clientId = data.clientId;
    

    let newOrder = (_.isString(order.id) && order.id.match(/new/) )
    let orderModel;
    let buyerModel = {id:null};

    //get the event info
    var eventInfo = await Models.Event.products(eventId);

    //just to make sure to get products from the server,
    //to not trust product received from the frontend
    _.each(purshaseProducts, purshaseProduct=>{
         purshaseProduct.product =  _.find(eventInfo.products, {id:purshaseProduct.productId});
    })

    // var totalPrice = calculatePrice.getFinalPriceForEvent(purshaseProducts,eventInfo);
    // var totalDiscount = calculatePrice.getTotalDiscount(purshaseProducts,eventInfo);
    // var totalTax = 0;

    // let orderDescription = "";
    // _.each(products, product=>{
    //     orderDescription+=''+product.fullname;
    // })

    let buyerInfo;
    let clientInfos = await Models.Client.findById(clientId);


      orderModel = await Order.findById(order.id);
    

    //now save products for the order
    for (let i = 0; i < purshaseProducts.length; i++) {
      const purshaseProduct = purshaseProducts[i];
      let myClienteId = clientId;
      if( _.isString(purshaseProduct.id) && purshaseProduct.id.match(/new/) ){
        delete purshaseProduct.id
      }
      if( _.has(purshaseProduct,clientId) ){
        myClienteId =  purshaseProduct.myClienteId
      }
      // // let purshaseProductModel = await orderModel.purchaseproducts.upsert( {...purshaseProduct} )
      // let purshaseProductModel = await Models.PurchaseProduct.upsert( {
      //                                 ...purshaseProduct, 
      //                                 name:purshaseProduct.product.fullname, 
      //                                 orderId:orderModel.id,
      //                                 clientId:myClienteId, 
      //                                 buyerId:buyerModel.id,
      //                                 eventId:buyerModel.id,
      //                             })
      
      for (let ii = 0; ii < purshaseProduct.members.length; ii++) {
        const member = purshaseProduct.members[ii];
       
        // let memberModel = await purshaseProductModel.members.upsert(member)
        let memberModel = await Models.Member.upsert({...member})

      }

      if( ! _.isEmpty(purshaseProduct.team[0]) ){
       
        let teamModel = await Models.Team.upsert( {...purshaseProduct.team[0] } )
      }
    }
    
    // //Pay the order
    // if( !order.payed && order.payedByAdmin !== false ){
    //   var payInfo = await orderModel.createPayment( data.paymentInfo, data.paymentOptionId );
    // }

    //load the complete order
    var completeOrder = await Order.findOne({where:{id:orderModel.id},
              include:['buyer',{'purchaseproducts':['product','members','team']}],                         
    })

    // var completeOrder = await Order.info({token:orderModel.token})

    //send email  
    // if(newOrder){
    //   setTimeout( ()=> Order.sendOrderPlaceEmail(completeOrder.token), 2000)
    // }

    // save order
    return { order:completeOrder.toJSON(), payment:{}}

  }


    // PAY AN ORDER 

    Order.prototype.createPayment = async function(paymentInfo, paymentOptionId, buyerId, req){
   
     
      //obscurate creditcard number and cvv and duodate
      const paymentInfoToSave = Object.assign({},paymentInfo);
      if(paymentInfo.cardnumber){
        paymentInfoToSave.cardnumber = "xxxx-xxxx-xxxx-"+paymentInfo.cardnumber.substr(-4);
        paymentInfoToSave.cvv = "xxx";
        paymentInfoToSave.duedate = "xx/xxxx";
      }


      //quando crio um novo pagamento, devo cancelar o antigo se existir?
      const lastPayment = await this.payments.findOne({order:'id DESC'});
      if(lastPayment){
        await lastPayment.cancel();
      }

       //create the payment 
       let payment = await this.payments.create({
          paymentInfo:paymentInfoToSave,
          PaymentOptionForEventId:paymentOptionId,
          totalPayed:this.totalPrice,
          totalDiscount:this.totalDiscount,
          buyerId:buyerId,
          //LETODO - include total tax
        //   totalTax:this.totalTax,
        })

        let paymentInfoToPay = Object.assign({},paymentInfoToSave,paymentInfo);

        let res = await payment.pay(paymentInfoToPay, req);
  
        return res;
    }


    Order.prototype.getBuyer = async function(){
        let buyer;
        if(this.buyerId != undefined){
          buyer = await this.buyer.get();
        }else{
          buyer = await this.client.get();
        }
        return buyer.toJSON();
    }


    Order.prototype.getProducts = async function(){
        let products = await this.purchaseproducts.find();
        return JSON.parse(JSON.stringify(products));
    }



  Order.sendOrderPlaceEmail = async function (token, completeOrder) { 

      console.log("========== Order.sendOrderPlaceEmail - start")
     
      try{
     
      let order = completeOrder ? completeOrder : await Order.info({token:token});

      let eventName = order.orderDescription.split('/')[0]
    
      let user = await Order.app.models.Client.findById(order.clientId);
      // order._paymentType = _.get( payoption, 'paymentType','none')
      // order = order.toJSON();
      
      if(order._paymentType == 'boleto'){
        // await payInfo.capture();
        // order._paymentLink = await payInfo.getLink();
        Order.app.models.Sendmail.sendMail({
          to: user.email,
          subject: "Recebemos sua inscrição - "+eventName,
          template: "order-with-boleto.ejs",
          data: {order:order}
        });
      }else if(order._paymentType == 'credit'){
        Order.app.models.Sendmail.sendMail({
          to: user.email,
          subject: "Recebemos sua inscrição - "+eventName,
          template: "order-with-credit.ejs",
          data: {order:order}
        });
      }else if(order._paymentType == 'pix'){
        Order.app.models.Sendmail.sendMail({
          to: user.email,
          subject: "Recebemos sua inscrição - "+eventName,
          template: "order-with-pix.ejs",
          data: {order:order}
        });
      // pode ser um pagamento que deu erro, ai não tem o paymentType ja que não foi gerado
    }else if(order.payed){
      Order.app.models.Sendmail.sendMail({
        to: user.email,
        subject: "Recebemos sua inscrição - "+eventName,
        template: "order-without-payment-needed.ejs",
        data: {order:order}
      });
      }else{
        Order.app.models.Sendmail.sendMail({
          to: user.email,
          subject: "Recebemos sua inscrição - "+eventName,
          template: "order-without-payment.ejs",
          data: {order:order}
        });

      }
    }catch(e){
      console.log("========== Order.sendOrderPlaceEmail - error", e)
    
    }

    console.log("========== Order.sendOrderPlaceEmail - end")

  }


  Order.sendPayedEmail = async function (token) { 

    console.log("========== Order.sendPayedEmail - start")
    
    try{
      let order = await Order.info({token:token});
      let eventName = order.orderDescription.split('/')[0]
      let user = await Order.app.models.Client.findById(order.clientId);
      await Order.app.models.Sendmail.sendMail({
          to: user.email,
        subject: "Confirmação de pagamento - "+eventName,
        template: "order-payed.ejs",
        data: {order:order}
      });
    }catch(e){
      console.log("========== Order.sendPayedEmail - error")
      
    }

    console.log("========== Order.sendPayedEmail - end")

}

  Order.sendCanceledEmail = async function (token) { 

    console.log("========== Order.sendCanceledEmail - start")

    try {
        let order = await Order.info({token:token});
        let user = await Order.app.models.Client.findById(order.clientId);
        
        await Order.app.models.Sendmail.sendMail({
            to: user.email,
            subject: "Pagamento NÃO autorizado ou Cancelado!",
            template: "order-canceled.ejs",
            data: {order:order}
        });
    } catch (error) {
        console.error("Erro ao enviar e-mail de cancelamento:");
    }

    console.log("========== Order.sendCanceledEmail - end")

}



  Order.info = async function (data) { 


    console.log("========== ORDER.info - start")
     
    let token = _.get(data,'token',_.get(data,'query.token', _.get(data,'body.token'), false))

    // Order.sendOrderPlaceEmail({token});

    if(!token){
      //LETODO - verificar voltar erro com httpstatus certinho etc
      throw Error('Sem nº de pedido informado')
      return false;
    }

    var where = {token:token}
    //capture order payments first and process
    var order =  await Order.findOne({ where,
        include:['payments']
    })  
    
    //tenta achar a ordem pelo id e não token
    if(!order){
      where = {id:token}
      order =  await Order.findOne({where,
        include:['payments']
      })  
    }

    if(!order){
      throw Error('Não foi possível encontrar a ordem com o token ou id informado')
    }

    // const eventOwner = await Order.app.models.Event.findOne({ where: { id: order.eventId } });
    // const currentUser = 

    // if(eventOwner.clientId != order.clientId){
    //   throw Error('Não foi possível encontrar a ordem com o token ou id informado')
    // }



    //check if i have a payment payed, 
    //if have set order payment to true
    // TODO 0
    let payed = false;
    for (let i = 0; i < order.__data.payments.length; i++) {
      let payment = order.__data.payments[i];
      if(payment.status == 'payed'){
        payed = true
      }
    }

    if(payed && order.payed==false ){
      order.payed = true;
      order.paymentStatus = 'payed';
      console.log("========== ORDER.info - atualiza order como payed")
      await order.save()
    }

    if(!order.payed ){
      for (let i = 0; i < order.__data.payments.length; i++) {
          let payment = order.__data.payments[i];
          if(payment.status == 'canceled'){
            continue;
          }
         try{
           let res = await payment.capture()  
         }catch(e){
           console.log(e)
         }
      }
    }else{
      //se ja é uma ordem paga, preciso verificar se não estornou ou deu algum problema
      // depois de payed.
      let payment = order.__data.payments[order.__data.payments.length-1];
      try{
        let res = await payment.capture();
      }catch(e){
        console.log(e)
      }
    }


     var completeOrder = await Order.findOne({where,
          // include:['buyer', 'client', {'purchaseproducts':['product','members','team']}, { 'payments':['PaymentOptionForEvent']}], //{'purchaseproducts':['product','members','team']}],
          include:[ 
            'buyer', 
            'client',
            'cupom',
            { relation:'payments',
              scope:{
                where:{'status':{neq:null}},
                order:'modified DESC',
                include:{
                  relation:'PaymentOptionForEvent',
                  scope:{
                    fields:['paymentType','id']
                  }
                }
              }
            },
            { relation:'purchaseproducts',
              scope:{
                fields:['name','price','productId','id'],
                include:[
                  {relation:'members',
                    scope:{
                      fields:['infos','id']
                    } 
                  },
                  {relation:'team',
                    scope:{
                      fields:['infos','id']
                    } 
                  },
                  {relation:'product',
                    scope:{
                      fields:['name','id','fullname']
                    } 
                 },
                ]
              }
          }
          ]
           //  include:['buyer', 'client', {'purchaseproducts':['product','members','team']}, { 'payments':['PaymentOptionForEvent']}], //{'purchaseproducts':['product','members','team']}],
     })
     
     completeOrder = completeOrder.toJSON();

     
    //now check if any payment is payed, or if we are payed as admin
     let paymentStatus = 'error'
     let paymentToConsider;
     if(completeOrder.payedByAdmin){
        completeOrder.payed = true;
        // completeOrder.paymentStatus = 'payed';
     }else{
        //loop payments to see if we have a payed
        paymentToConsider = _.find( completeOrder.payments, {status:'payed'} )
        if(! paymentToConsider){
            //get payment status from last take payment
            paymentToConsider = _.get( completeOrder, 'payments[0]',{status:'error'} )
        }
     }


     completeOrder._paymentType = _.get( paymentToConsider, 'PaymentOptionForEvent.paymentType','none')
     
     if( (completeOrder._paymentType == 'boleto' || completeOrder._paymentType == 'pix' )
          && paymentToConsider.status == "waiting" ){
          //get the link of this payment
          let payment = await order.payments.findById(paymentToConsider.id)
          completeOrder._paymentLink = await payment.getLink()
          completeOrder._infoMeta = await payment.getInfoMeta()
     }
     
     let currentStatus = _.get( paymentToConsider, 'status','');
     
     //remove the sensitive payment info data
     _.each(completeOrder.payments, p => { delete p.paymentInfo, p.PaymentOptionForEvent })


     console.log("========== ORDER.info - end")
      return completeOrder;
  }



  /** Atualização em lote de todas as inscrições */
  Order.updateInfos = async function (data) { 

    //get all orders
    let orders = await Order.find({
      include:['payments']
    });

    for (let i = 0; i < orders.length; i++) {
      const order = orders[i];
      let clientId = order.clientId;
      let paymentStatus = order.paymentStatus;
      let payed = order.payed;
      let created = order.created;
      let modified = order.modified;
      let eventId = order.eventId;
      //update clientInfo of products
      //update paymentStatus
      await Order.app.models.PurchaseProduct.updateAll({orderId:order.id},{paymentStatus, payed, clientId, created, modified, eventId  })
    }

    for (let i = 0; i < orders.length; i++) {
      const order = orders[i];
      if(! order.payed ){
      for (let i = 0; i < order.__data.payments.length; i++) {
          let payment = order.__data.payments[i];
         try{
           let res = await payment.capture()  
         }catch(e){
           console.log(e)
         }
      }
    }
    
    }
  }







  Order.remoteMethod('paymentReturn', {
    accepts: {
        "arg": "data",
        "type": "object",
        http: { source: 'req' }
    },
    returns: {
        arg: 'body',
        type: 'object',
        root:true,
    },
    http: {verb: 'post', source: "req"},
    isStatic: true
  });

  Order.remoteMethod('updateInfos', {
    accepts: {
        "arg": "data",
        "type": "object",
        http: { source: 'req' }
    },
    returns: {
        arg: 'body',
        type: 'object',
        root:true,
    },
    http: {verb: 'post', source: "req"},
    isStatic: true
  });


  Order.remoteMethod('place', {
    accepts: 
      {
        "arg": "data",
        "type": "object",
        http: { source: 'req' }
      },
    returns: {
        arg: 'body',
        type: 'object',
        root:true,
    },
    http: {verb: 'post', source: "req"},
    isStatic: true
  });

  Order.remoteMethod('save', {
    accepts: {
        "arg": "data",
        "type": "object",
        http: { source: 'req' },
    },
    returns: {
        arg: 'body',
        type: 'object',
        root:true,
    },
    http: {verb: 'post', source: "req"},
    isStatic: true
  });


  Order.remoteMethod('info', {
    accepts: {
        "arg": "data",
        "type": "object",
        http: { source: "req" }
    },
    returns: {
        arg: 'body',
        type: 'object',
        root:true,
    },
    http: {verb: 'get', source: "req"},
    isStatic: true
  });




  Order.observe("before save", async function (ctx) {


    console.log("========== ORDER.before save - start")

    
    if (ctx.isNewInstance === true) {
      console.log("========== ORDER.before save - gera token")
      let id = ctx.instance.id || Date.now();      
      ctx.instance.token = crypto.createHash('md5').update(id.toString()).digest('hex');
     
    }else{
      console.log("========== ORDER.before save - Ja existe, so atualiza se payed ou nnao")
       // Atualização de registro
       const instance = _.get(ctx, 'instance', _.get(ctx, 'currentInstance'));
      const orderId = instance.id;
      const oldOrder = await Order.findById(orderId);
      if (oldOrder) {
        if(oldOrder.payed !== instance.payed){
          if(instance.payed === true){
            setTimeout( ()=> Order.app.models.Order.sendPayedEmail(instance.token), 10000)
          }
        }
      }
    }

    console.log("========== ORDER.before save - end")

    // next();

  })

  // //create a token for the order
  Order.observe("after save", function (ctx, next, options) {


    console.log("========== ORDER.after save - start")
    console.log("ctx.currentInstance.payed:", ctx.currentInstance ? ctx.currentInstance.payed : "undefined");
    console.log("ctx.data.payed:", ctx.data ? ctx.data.payed : "undefined");
    debugger;
    if (ctx.isNewInstance === true) {
      console.log("========== ORDER.after save - retorno sem atualizar produtos")
      return next();
    }

    let order = ctx.instance

    //update the related purshase products with payment status
    let paymentStatus = ctx.instance.paymentStatus;
    let payed = ctx.instance.payed;
    
    let clientId = order.clientId;
    let created = order.created;
    let modified = order.modified;
    let eventId = order.eventId;

    console.log("========== ORDER.after save - atualiza produtos")
    Order.app.models.PurchaseProduct.updateAll({orderId:order.id},{paymentStatus, payed, clientId, created, modified, eventId  })
    console.log("========== ORDER.after save - atualiza produtos - end")

    next();
    
  })




};
